import { createBrowserHistory, createHashHistory } from "@tanstack/history";
import { RouterProvider, createRouter } from "@tanstack/react-router";

import { SuspenseLoadingScreen } from "@/components/loading-screen";
import { useCapacitor } from "@/hooks/use-capacitor";
import { NotFoundPage } from "@/pages/NotFound/index";
import { routeTree } from "@/routeTree.gen";

declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }
}

// *Create router instance - TanStack Router uses browser history by default
const history = typeof window !== "undefined" && Boolean(window.cordova) ? createHashHistory() : createBrowserHistory();

const router = createRouter({
    routeTree,
    defaultPreload: "intent",
    history,
    // *Provide a default context value so the router context stays typed everywhere.
    context: {
        isCapacitor: false,
    },
    // *Default loading UI
    defaultPendingComponent: SuspenseLoadingScreen,
    // *Router-wide not found component.
    defaultNotFoundComponent: NotFoundPage,
});

export const Router = () => {
    const { isCapacitor } = useCapacitor();

    return (
        <RouterProvider
            router={router}
            context={{
                isCapacitor,
            }}
        />
    );
};
